import React, { useCallback, useEffect, useState } from "react";
import { CheckIcon, LinkIcon } from "@heroicons/react/20/solid";

/**
 * Copies the current URL, which carries the whole filter slice (see
 * utils/viewUrl) — so "look at this" becomes a link rather than a list of
 * filters to re-apply by hand (#1416).
 */
export function CopyLinkButton() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  const copy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
    } catch {
      // Clipboard access can be denied (insecure origin, permissions). The URL
      // is in the address bar either way, so fail quietly rather than alarm.
    }
  }, []);

  return (
    <button
      type="button"
      onClick={copy}
      className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring rounded px-1.5 py-1"
    >
      {copied ? (
        <CheckIcon className="h-4 w-4 text-success" aria-hidden="true" />
      ) : (
        <LinkIcon className="h-4 w-4" aria-hidden="true" />
      )}
      {copied ? "Link copied" : "Copy link"}
    </button>
  );
}
